<!-- footer -->
<template>
    <div class="footer-wrap">
        <div class="footer-top">
            <div style="width: 320px">
                <p class="footer-title">Contáctanos</p>
                <p>
                    Torres Adalid 618 , interior 3, Colonia Del Valle Centro, C.P. 03100, Benito Juárez, Ciudad de México<br />
                    servicio@tuku.mx
                </p>
            </div>
            <div>
                <p class="footer-title">Conoce más sobre Futuro</p>
                <div class="wrap-cursor">
                    <p @click="toTop">Préstamos inmediatos.</p>
                    <p @click="toTop">Préstamos sin aval.</p>
                    <p @click="toTop">Préstamos personales.</p>
                    <p @click="toTop">Préstamos en línea.</p>
                    <p @click="toTop">Préstamos rápidos sin aval.</p>
                </div>
            </div>
            <div>
                <p class="footer-title">Síguenos en</p>
                <div>
                    <img
                        src="../assets/images/facebook.png"
                        alt=""
                        class="img-facebook"
                        @click="toFaceBook" />
                </div>
            </div>
            <div class="wrap-logo">
                <img
                    src="../assets/images/logo.png"
                    alt=""
                    class="img-logo footer-title" />
                <!-- <p>Futuro Pyme S.A. de C.V., SOFOM,</p>
				<p>E.N.R.</p>
				<p>Torres Adalid 618, Int. 3, Del Valle</p>
	 			<p>Centro, 03100, Benito Juárez,</p>
				<p>CDMX.</p> -->
            </div>
        </div>

        <div class="footer-bottom">
            <img
                src="../assets/images/footer1.png"
                alt=""
                class="img-round" />
            <p>El Buró de Entidades Financieras contiene información de Futuro Pyme, S.A. de C.V., SOFOM, E.N.R. sobre nuestro</p>
            <p>desempeño frente a los Usuarios, por la prestación de productos y servicios. Te invitamos a consultar también en la</p>
            <p>
                página
                <a
                    class="link"
                    href="https://www.buro.gob.mx/"
                    target="_black"
                    >https://www.buro.gob.mx/ </a
                >o a través de
            </p>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {

        }
    },
    created () {

    },
    mounted () {

    },
    methods: {
        toFaceBook () {
            window.open('https://www.facebook.com/Futuroapp-110664585302086', '_blank')
        },
        goAgreement (key) {
            this.$router.push({
                path: '/agreement',
                query: {
                    key
                }
            })
        },
        goHelp (key) {
            this.$router.push({
                path: '/help',
                query: {
                    key
                }
            })
        },
        toTop () {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            })
        },
        goPrivacidad () {
            window.open('https://loansapp.futuro.mx/api/getProtocolBeforeLoan?agreementName=futuro-privacidad.html', '_target')
        }
    }
}
</script>
<style  scoped>
.footer-wrap {
    width: 100%;
    background: #22252a;
}

.footer-wrap > div {
    width: 1200px;
    margin: 0 auto;
    color: rgba(255, 255, 255, 0.7);
}
.footer-wrap > div p {
    font-size: 13px;
    line-height: 24px;
}
.footer-top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 57px 45px 37px;
    border-bottom: 1px dashed hsla(0, 0%, 59%, 0.27);
    border-width: 3px;
    box-sizing: border-box;
}
.img-facebook {
    width: 84px;
    cursor: pointer;
}
.img-logo {
    width: 74px;
}
.footer-title {
    color: rgba(255, 255, 255, 0.9);
    font-size: 14px;
    margin-bottom: 16px;
}
.wrap-cursor {
    cursor: pointer;
}
.footer-bottom {
    padding: 32px 45px;
    box-sizing: border-box;
}

.img-round {
    width: 48px;
    margin-bottom: 8px;
}
.wrap-link > p,
.link {
    color: #ffbc1c;
    cursor: pointer;
}

.footer-logo {
    width: 58px;
}
.column-line {
    margin: 0 39px;
    height: 39px;
    opacity: 0.34;
    border-left: 1px solid #979797;
}
.icon-footer {
    width: 14px;
    vertical-align: middle;
}
.footer-title {
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    color: #ffffff;
    line-height: 20px;
    margin-right: 24px;
}
.footer-phone {
    margin-left: 64px;
}
.footer-des {
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    text-align: left;
    color: rgba(255, 255, 255, 0.7);
    line-height: 20px;
}
.footer-address {
    margin-top: 10px;
}
.wrap-logo {
    background: #fff;
    height: auto;
}
.wrap-logo img {
    margin-right: 0;
    margin-bottom: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/FooterNew.vue